import { render, staticRenderFns } from "./ChannelLink.vue?vue&type=template&id=0a2f4bd9&"
import script from "./ChannelLink.vue?vue&type=script&lang=js&"
export * from "./ChannelLink.vue?vue&type=script&lang=js&"
import style0 from "./ChannelLink.vue?vue&type=style&index=0&id=0a2f4bd9&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports